import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

const About = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/council-members`)
      .then(({ data }) => setMembers(data.members || []))
      .catch(() => setMembers([]));
  }, []);

  return (
    <div className="min-h-screen">
      {/* Dark Hero Banner */}
      <section className="bg-[#1a1a2e] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white uppercase mb-2">ABOUT US</h1>
          <div className="w-20 h-1 bg-[#dc2626] mx-auto"></div>
        </div>
      </section>

      <div className="container mx-auto px-4 py-12">
          <div className="space-y-8">

            {/* Sports Chiropractic Section */}
            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-[#2c3e7d] mb-2 uppercase">SPORTS CHIROPRACTIC</h2>
                <div className="w-20 h-1 bg-[#dc2626] mb-6"></div>
                <div className="space-y-4 text-gray-700 leading-relaxed">
                  <p>
                    Sports chiropractic is also known as chiropractic sports sciences/medicine. The
                    focus of sports chiropractors is to provide care in the conservative management,
                    rehabilitation and performance optimization of neuromusculoskeletal system for
                    athletes and to participate in a multi-disciplinary sports injury care
                    environment.
                  </p>
                  <p>
                    Sports chiropractic achieves this focus through the application of a multimodal
                    treatment approach that include one or more of the following: manipulation,
                    mobilisation, soft tissue therapies, electrotherapy, rehabilitation and other
                    movement/exercise therapies, nutritional advice, strapping and bracing and other
                    related approaches. These approaches are applied to injury management in the form,
                    of acute, subacute and chronic injury as well as in the prevention of injury and
                    the optimisation of athletic performance through the pursuit of the highest
                    efficiency in neuromusculoskeletal functioning.
                  </p>
                  <p>
                    A Sports Chiropractor may possess additional qualifications specific to sport.
                    Those chiropractors who have pursued additional study have assimilated a large body
                    of clinical information specific to the special needs of those who participate in
                    sport.
                  </p>
                  <p>
                    Sports chiropractic is growing rapidly nationally and internationally and is well
                    established at many world level sporting events, such as the Olympic Games and the
                    World Games. The Federation of International Chiropractic Sport (FICS) is the peak,
                    international sports chiropractic body and plays a dominant role in promoting
                    sports chiropractic throughout the world. FICS is made up of many national sports
                    chiropractic councils. These include sports chiropractic councils from South Africa,
                    The United States, The United Kingdom, Australia, New Zealand, Switzerland, Japan,
                    Russia, Italy, Germany, and many others.
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Vision & Mission Section */}
            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-[#2c3e7d] mb-2 uppercase">Vision & Mission</h2>
                <div className="w-20 h-1 bg-[#dc2626] mb-6"></div>

                <div className="mb-6">
                  <h3 className="text-xl font-semibold text-[#2c3e7d] mb-3">Vision Statement</h3>
                  <p className="text-gray-700 leading-relaxed italic">
                    To enhance the health of physically active sports men and women through
                    chiropractic care, and to increase integration and cooperation with others
                    involved in sports healthcare.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#2c3e7d] mb-4">Mission Statement</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-[#2c3e7d] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        To enhance and develop the expertise of chiropractors who are active in sports
                        injury prevention and management through education, research and professional
                        relationships
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-[#2c3e7d] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        To create a means for connecting the public with chiropractors with an interest
                        and skills in sports chiropractic
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-[#2c3e7d] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        Share knowledge and resources to further aid in the understanding of performance
                        enhancement, injury prevention and injury management
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-[#2c3e7d] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        Develop partnerships with like organisations for the benefit of the South African
                        sporting community
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-[#2c3e7d] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>
                        Be an active and valuable member of the sports medicine community in South
                        Africa.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-2 h-2 bg-[#2c3e7d] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>Contribute to creating a safer sporting environment for all South Africans.</span>
                    </li>
                  </ul>
                </div>
              </CardContent>
            </Card>

            {/* Council & Committee Section */}
            <Card>
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-[#2c3e7d] mb-2 uppercase">Council & Committee</h2>
                <div className="w-20 h-1 bg-[#dc2626] mb-8"></div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  {members.map((member) => (
                    <div key={member.id} className="text-center group" data-testid={`council-member-${member.id}`}>
                      <div className="mb-4 overflow-hidden rounded-lg">
                        <img
                          src={member.image_url ? (member.image_url.startsWith('/council/') ? member.image_url : `${API}${member.image_url}`) : '/council/placeholder.jpg'}
                          alt={member.name}
                          className="w-full h-64 object-contain bg-gray-100 group-hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                      <h3 className="font-semibold text-gray-900 mb-1">{member.name}</h3>
                      <p className="text-sm text-blue-600">{member.position}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
      </div>
    </div>
  );
};

export default About;
